import axios from 'axios'
import { useEffect, useState } from 'react'
import { BRAINDW_EMPTY_OBJ, BRAINDW_PRODUCTS_GETTER_URL } from 'src/constants'

export const useBraindw = ({ ids, session }: UseBraindwProps) => {
  const [braindwObject, setBraindwObject] = useState<
    BraindwObjectProps[] | null
  >(null)

  const [cliBDWObj, setCliBDWObj] =
    useState<BraindwObjectInfoProps>(BRAINDW_EMPTY_OBJ)

  useEffect(() => {
    const bdwObject = localStorage.getItem('braindw_object')

    if (bdwObject) {
      const parsedBdwObject: BraindwObjectInfoProps = JSON.parse(bdwObject)

      setCliBDWObj((prevObj) => ({
        ...prevObj,
        history: parsedBdwObject.history,
        current: parsedBdwObject.current,
        enable: parsedBdwObject.enable,
      }))
    }
  }, [])

  useEffect(() => {
    const fetchBraindwData = async () => {
      try {
        const response = await axios.post(
          BRAINDW_PRODUCTS_GETTER_URL,
          {
            ...cliBDWObj,
            filterSectionId: ids ?? [],
            session: {
              name: session?.person?.givenName ?? '',
              email: session?.person?.email ?? '',
              branchOffice: session?.channel
                ? JSON.parse(session.channel).salesChannel
                : 4,
              sellerId:
                JSON.parse(localStorage.getItem('Location') ?? '{}')
                  ?.sellerId ?? '',
              country: session?.country ?? '',
            },
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )

        setBraindwObject(response.data)
      } catch (error) {
        throw new Error(error)
      }
    }

    if (!braindwObject && !session.isValidating) {
      fetchBraindwData()
    }
  }, [braindwObject, session, cliBDWObj, ids])

  return {
    braindwObject,
  }
}
